"use client";

import { type Dispatch, type SetStateAction, createContext, useContext } from "react";
import type { UseDebounceResult } from "../hooks/useDebounce";

interface CardContextValue {
	openCards: string[];
	onOpenCardsChange: (newOpenCards: string[]) => void;
	navigateToCard: (currentCard: string, nextCard: string, scroll?: boolean) => void;
	showVisualisation: boolean;
	setShowVisualisation: Dispatch<SetStateAction<boolean>>;
	scrollToElement: (identifier: string) => void;
	invalidCards: string[];
	setInvalidCards: Dispatch<SetStateAction<string[]>>;
	focused: boolean;
	setFocused: Dispatch<SetStateAction<boolean>>;
	onFocus: UseDebounceResult;
}

export const CardContext = createContext<CardContextValue>({} as CardContextValue);

export function useCardContext() {
	const context = useContext(CardContext);

	if (context === null) throw new Error("CardContext is not available");

	return context;
}
